var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-default pull-right btn-lg",attrs:{"title":_vm._traducao('global', 'voltar')},on:{"click":_vm.click}},[_c('i',{staticClass:"icon-left botao_i",attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }